import { Col, Input, Row } from 'antd'
import { useState } from 'react'
import { HelpMessage } from 'utils/constants'
import CIMSFormItem from 'components/CIMSFormItem'
import CIMSSelect from 'components/CIMSSelect'
import { ConnectionType } from './types'
import CreateGoogleSheetBody from './CreateGoogleSheetBody'
import GroupSelect from '../../../../GroupSelect'
import { useConnectionsContext } from '../../../ConnectionsContext'

const CreateBody: React.FC = () => {
  const [type, setType] = useState<ConnectionType | undefined>(
    ConnectionType.GoogleSheet
  )
  const { groups, fetching } = useConnectionsContext()
  return (
    <>
      <Row gutter={32}>
        <Col md={12} sm={1}>
          <CIMSFormItem label="Name" name="name" help={HelpMessage.Name}>
            <Input allowClear />
          </CIMSFormItem>
        </Col>
        <Col md={12} sm={1}>
          <GroupSelect options={groups} loading={fetching} />
        </Col>
      </Row>
      <CIMSFormItem label="Connection Type">
        <CIMSSelect
          simple
          defaultValue={ConnectionType.GoogleSheet}
          options={Object.values(ConnectionType).map((value) => ({
            label: value,
            value,
          }))}
          onChange={(value) => setType(value as ConnectionType)}
        />
      </CIMSFormItem>
      {type === ConnectionType.GoogleSheet && <CreateGoogleSheetBody />}
    </>
  )
}

export default CreateBody
